import React from "react";
import ScrollToTop from "../hooks/ScrollToTop";
import UserLayout from "./UserLayout";
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from "../pages/Home/Home"
import RoomListing from "../pages/RoomListing/RoomListing";
import Contact from "../pages/Contact/Contact";
import OfferListing from "../pages/OfferListing/OfferListing";
import OfferDetail from "../pages/OfferDetail/OfferDetail";
import Thankyou from "../pages/Thankyou/Thankyou";
import Error from '../pages/404/Error';
import About from "../pages/About/About";
import Rishikesh from "../pages/Rishikesh/Rishikesh";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import Faqs from "../pages/TermFaqs/Faqs";
import Goa from "../pages/Goa/Goa";
import Wedding from "../pages/wedding/Wedding";
import Cuisine from "../pages/cuisine/Cuisine";
import BlogListing from "../pages/BlogListing/BlogListing";
import BlogDetail from "../pages/BlogDetail/BlogDetail";
import Meeting from "../pages/Meeting/Meeting";
import Gallery from "../pages/Gallery/Gallery";
import Spa from "../pages/Spa/Spa";
import Jimcorbett from "../pages/Jimcorbett/Jimcorbett";
import MeetingGoa from "../pages/MeetingGoa/MeetingGoa";
// import MeetingRishikesh from "../pages/MeetingRishikesh/MeetingRishikesh";
import CuisineGoa from "../pages/cuisineGoa/CuisineGoa";
import CuisineRishikesh from "../pages/cuisineRishikesh/CuisineRishikesh";
// import SpaGoa from "../pages/SpaGoa/SpaGoa";
// import SpaRishikesh from "../pages/SpaRishikesh/SpaRishikesh";
import RoomlistingGoa from "../pages/RoomListingGoa/RoomlistingGoa";
import RoomlistingRishikesh from "../pages/RoomListingRishikesh/RoomlistingRishikesh";

import GoaPremium from "../pages/AllroomDetail/GoaRoom/GoaPremium";
import GoaSuperdeluxe from "../pages/AllroomDetail/GoaRoom/GoaSuperdeluxe";
import GoaSuite from "../pages/AllroomDetail/GoaRoom/GoaSuite";
import GoaStandard from "../pages/AllroomDetail/GoaRoom/GoaStandard";
import GoaDeluxe from "../pages/AllroomDetail/GoaRoom/GoaDeluxe";
// import GoaCornerdeluxe from "../pages/AllroomDetail/GoaRoom/zzzGoaCornerdeluxe";

import CorbettClub from "../pages/AllroomDetail/CorbettRoom/CorbettClub";
import CorbettPremium from "../pages/AllroomDetail/CorbettRoom/CorbettPremium";
import CorbettLuxurycottages from "../pages/AllroomDetail/CorbettRoom/CorbettLuxurycottages";
import CorbettLuxuryroom from "../pages/AllroomDetail/CorbettRoom/CorbettLuxuryroom";
import CorbettFamilycottages from "../pages/AllroomDetail/CorbettRoom/CorbettFamilycottages";

import RishikeshClub from "../pages/AllroomDetail/RishikeshRoom/RishikeshClub";
import RishikeshPremium from "../pages/AllroomDetail/RishikeshRoom/RishikeshPremium";
import RishikeshLuxurycottages from "../pages/AllroomDetail/RishikeshRoom/RishikeshLuxurycottages";
import RishikeshLuxuryroom from "../pages/AllroomDetail/RishikeshRoom/RishikeshLuxuryroom";
import RishikeshFamilycottages from "../pages/AllroomDetail/RishikeshRoom/RishikeshFamilycottages";
import EnquiryPopup from "../component/EnquiryPopup";
import { useModal } from "../contexts/ModalContext";
import PetFriendly from "../pages/PetFriendly/PetFriendly";
import ComingSoon from "../pages/ComingSoon/ComingSoon";

export default function NavRouter({ initialData, initialFaq }) {
  const { modalShow, closeQueryModal } = useModal();

  return (
    <>
      <ScrollToTop />
      <EnquiryPopup show={modalShow} setShow={closeQueryModal} />

      <Routes>
        {/* Routes with image header */}
        <Route path="/" element={<UserLayout headerClass={`white-header`} />}>
          <Route index element={<Home />} />
          <Route path="offer-listing" element={<OfferListing initialData={initialData} />} />
          <Route path="offer-listing/:offer_slug" element={<OfferDetail initialData={initialData} />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="about-us" element={<About />} />

          <Route path="resort-de-coracao-rishikesh" element={<Rishikesh />} />
          <Route path="resort-de-coracao-goa" element={<Goa />} />
          <Route path="resort-de-coracao-corbett" element={<Jimcorbett />} />

          <Route path="resort-de-coracao-corbett/cuisine" element={<Cuisine />} />
          <Route path="resort-de-coracao-goa/cuisine" element={<CuisineGoa />} />
          <Route path="resort-de-coracao-rishikesh/cuisine" element={<CuisineRishikesh />} />

          <Route path="resort-de-coracao-corbett/spa-wellness" element={<Spa />} />
          {/* <Route path="resort-de-coracao-goa/spa-wellness" element={<SpaGoa />} /> */}
          {/* <Route path="resort-de-coracao-rishikesh/spa-wellness" element={<SpaRishikesh />} /> */}

          <Route path="blog" element={<BlogListing initialData={initialData} />} />

          <Route path="resort-de-coracao-corbett/pet-friendly" element={<PetFriendly />} />
        </Route>

        {/* Routes with normal subheader */}
        <Route element={<UserLayout headerClass="" />}>
          <Route path="resort-de-coracao-corbett/room-listing" element={<RoomListing />} />
          <Route path="resort-de-coracao-goa/room-listing" element={<RoomlistingGoa />} />
          <Route path="resort-de-coracao-rishikesh/room-listing" element={<RoomlistingRishikesh />} />

          <Route path="resort-de-coracao-goa/premium-room" element={<GoaPremium />} />
          <Route path="resort-de-coracao-goa/super-deluxe-room" element={<GoaSuperdeluxe />} />
          <Route path="resort-de-coracao-goa/suite-room" element={<GoaSuite />} />
          <Route path="resort-de-coracao-goa/standard-room" element={<GoaStandard />} />
          <Route path="resort-de-coracao-goa/deluxe-room" element={<GoaDeluxe />} />
          {/* <Route path="resort-de-coracao-goa/corner-deluxe-room" element={<GoaCornerdeluxe />} /> */}

          <Route path="resort-de-coracao-corbett/club-cottages" element={<CorbettClub />} />
          <Route path="resort-de-coracao-corbett/premium-cottages" element={<CorbettPremium />} />
          <Route path="resort-de-coracao-corbett/luxury-cottages" element={<CorbettLuxurycottages />} />
          <Route path="resort-de-coracao-corbett/luxury-room" element={<CorbettLuxuryroom />} />
          <Route path="resort-de-coracao-corbett/family-cottages" element={<CorbettFamilycottages />} />

          <Route path="resort-de-coracao-rishikesh/suite" element={<RishikeshClub />} />
          <Route path="resort-de-coracao-rishikesh/premium-suite" element={<RishikeshPremium />} />
          <Route path="resort-de-coracao-rishikesh/super-deluxe" element={<RishikeshLuxurycottages />} />
          <Route path="resort-de-coracao-rishikesh/deluxe" element={<RishikeshLuxuryroom />} />
          <Route path="resort-de-coracao-rishikesh/ganga-suite" element={<RishikeshFamilycottages />} />


          <Route path="terms" element={<TermsConditions />} />
          <Route path="faqs" element={<Faqs />} />
          <Route path="resort-de-coracao-corbett/wedding" element={<Wedding />} />
          <Route path="blog/:blog_slug" element={<BlogDetail initialData={initialData} initialFaq={initialFaq} />} />

          <Route path="resort-de-coracao-corbett/meeting" element={<Meeting />} />
          <Route path="resort-de-coracao-goa/meeting" element={<MeetingGoa />} />
          {/* <Route path="resort-de-coracao-rishikesh/meeting" element={<MeetingRishikesh />} /> */}

          <Route path="/:gallery_slug/gallery" element={<Gallery initialData={initialData}/>} />
        </Route>

        {/* Routes without footer*/}
        <Route element={<UserLayout footerHide="footer-hider" />}>
          <Route path="404" element={<Error />} />
          <Route path="*" element={<Navigate to={"/404"} />} />
          <Route path="thankyou" element={<Thankyou />} />
        </Route>


        {/* Routes without footer / header*/}
        <Route element={<UserLayout footerHide="footer-hider" removeHeader={true}/>}>
          <Route path="coming-soon" element={<ComingSoon />} />
        </Route>

      </Routes>
    </>
  )
}
